import { ContentBlocksEffects } from './content-blocks.effect';

export const effects = [ContentBlocksEffects];
export * from './content-blocks.effect';
